export const MODELS_API_PATH = '/api/models';
export const MODELS_PATH = '/models';
export const API_REQUEST_KEY = 'MODELS';
